import {
  Checkbox,
  Divider,
  Grid,
  InputAdornment,
  ListItemText,
  MenuItem,
  Modal,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import "../../assets/css/Incarico.css";
import SelectCustom from "../Generics/Select";
import { LocalizationProvider, DatePicker } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { format, parse } from "date-fns";
import { it } from "date-fns/locale";
import { isValid } from "date-fns";

import "../../assets/css/text.css";
import ModalHelper from "../Generics/ModalHelper";
import { useSelector } from "react-redux";

const CompensationComponent = ({
  compenso = {},
  practice = {
    compenso: { pro_forma_fattura: "", dettagli_fatturazione_compenso: "" },
  },
  handleCompesoUpdate,
  errors,
}) => {
  const [modalOpen, setModalOpen] = useState(false);
  const [modalObjectInfo, setModalObjectInfo] = useState({});

  const tooltipContent = {
    pro_forma_fattura: {
      infoTitle: "Oggetto della pro-forma / fattura",
      description: (
        <>
          <Typography>
            L’oggetto della pro-forma / fattura deve contenere in modo ordinato
            tutte le voci relative alla fatturazione.
          </Typography>
          <Typography>
            Esempio: n.2 contratti di investimento; n.1 richiesta di visto per
            motivi di lavoro.
          </Typography>
        </>
      ),
    },
    riferimento_calcolo: {
      infoTitle: "Riferimento per il calcolo",
      description: (
        <Typography>
          Se selezioni il listino tariffa oraria standard, le tariffe applicate
          saranno le seguenti:
          <ul style={{ marginTop: "5px" }}>
            <li>Socio: €500 / h</li>
            <li>Of Counsel: €400 / h</li>
            <li>Counsel: €350 / h</li>
            <li>Senior Associate: €250 / h</li>
            <li>Associate: €150 / h</li>
            <li>Staff: €150 / h</li>
          </ul>
        </Typography>
      ),
    },
    Listino_Tariffa: {
      infoTitle: "Listino/Tariffa oraria da applicare",
      description: (
        <Typography>
          Se selezioni il listino tariffa oraria standard, le tariffe applicate
          saranno le seguenti:
          <ul style={{ marginTop: "5px" }}>
            <li>Socio: €500 / h</li>
            <li>Of Counsel: €400 / h</li>
            <li>Counsel: €350 / h</li>
            <li>Senior Associate: €250 / h</li>
            <li>Associate: €150 / h</li>
            <li>Staff: €150 / h</li>
          </ul>
        </Typography>
      ),
    },
    dettagli_compensi_outsourcing: {
      infoTitle: "Dettagli dei compensi per outsourcing",
      description: (
        <Typography>
          Indicare oltre ai compensi gli eventuali accordi sottostanti con i
          fornitori.
        </Typography>
      ),
    },
  };

  // codice per apertura info helper
  const handleModalClick = (objectInfo) => {
    setModalObjectInfo(objectInfo);
    setModalOpen(true);
  };

  const handleCloseModal = () => {
    setModalOpen(false);
    setModalObjectInfo({});
  };

  const listinoOptions = [
    "Listino nuovo tariffa 2025",
    "Listino nuovo 2025 sconto 5",
    "Listino nuovo 2025 sconto 10",
    "Listino nuovo 2025 sconto 15",
    "Listino nuovo 2025 sconto 20",
    "Listino nuovo 2025 sconto 25",
    "Listino nuovo 2025 sconto 30",
    "Listino nuovo 2025 sconto 35",
    "Listino nuovo 2025 sconto 40",
    "Listino nuovo 2025 sconto 50",
    "Listino flat fee €150 / h",
    "Listino flat fee €160 / h",
    "Listino flat fee €170 / h",
    "Listino flat fee €175 / h",
    "Listino flat fee €180 / h",
    "Listino flat fee €190 / h",
    "Listino flat fee €200 / h",
    "Listino flat fee €230 / h",
    "Listino flat fee €250 / h",
    "Listino flat fee €255 / h",
    "Listino flat fee €260 / h",
    "Listino flat fee €265 / h",
    "Listino flat fee €270 / h",
    "Listino flat fee €280 / h",
    "Listino flat fee €290 / h",
    "Listino flat fee €307 / h",
    "Listino flat fee €308,54 / h",
    "Listino flat fee €300 / h",
    "Listino flat fee €330 / h",
    "Listino personalizzato",
  ];

  const modalitàCompenso = ["Forfait", "Listino/Tariffa oraria", "Mista"];

  const percentualeSpese = [
    "No spese generali",
    "5%",
    "7,5%",
    "10%",
    "15%",
    "Altra percentuale",
  ];

  const compensoCondiviso = ["Sì", "No"];

  const condizioniPagamento = [
    "A vista",
    "15 giorni data fattura",
    "30 giorni data fattura",
    "60 giorni data fattura",
    "90 giorni data fattura",
    "RI.BA.",
  ];

  const compensiOutsourcing = ["Sì", "No"];

  const handleChange = (name, value) => {
    let updatedCompenso = { ...practice?.compenso };

    if (name === "modalità_compenso") {
      updatedCompenso["riferimento_calcolo"] = "";
      updatedCompenso["tariffa_oraria"] = "";
    }

    if (name === "percentuale_spese" && value !== "Altra percentuale") {
      updatedCompenso["percentuale_spese_specifica"] = "";
    }

    if (name === "modalità_compenso" || name === "riferimento_calcolo") {
      updatedCompenso["tariffa_specifica"] = "";
    }

    if (name === "team_compenso_condiviso") {
      updatedCompenso[name] = value;
    } else {
      updatedCompenso[name] = value;
    }

    const updatedPractice = {
      ...practice,
      compenso: updatedCompenso,
    };

    handleCompesoUpdate(updatedPractice);
  };

  const team = useSelector((state) => state.user?.redux_object?.team || "");

  const teamArray = Array.isArray(team) ? team : Object.values(team);

  const filteredTeamArray = teamArray
    .filter((item) => item.id !== practice.Incarico.Team_riferimento.id)
    .sort((a, b) => a.name.localeCompare(b.name));

  return (
    <>
      <Grid
        container
        style={{
          display: "flex",
          justifyContent: "center",
        }}
      >
        <Grid
          item
          xs={11}
          sm={10}
          style={{
            overflowY: "auto",
            marginTop: "30px",
          }}
        >
          {/* Title */}
          <Grid
            xs={12}
            spacing={4}
            item
            container
            style={{
              display: "flex",
              justifyContent: "center",
            }}
          >
            <Grid item xs={11} md={4}>
              <Typography className="color-blue-dark title-step">
                Compenso
              </Typography>
            </Grid>

            <Grid item xs={11} md={4} style={{ paddingTop: "0px" }}></Grid>

            <Grid item xs={11} md={4} style={{ paddingTop: "0px" }}></Grid>
          </Grid>

          <Grid
            xs={12}
            spacing={4}
            item
            container
            sx={{
              display: "flex",
              justifyContent: { xs: "center", md: "flex-start" },
              marginBottom: "50px",
              marginTop: "2px",
            }}
          >
            {/* Pro forma - fattura */}
            <Grid item xs={11} md={4}>
              <div
                style={{
                  display: "flex",
                  height: "20px",
                }}
              >
                <Typography className="color-blue-dark title-input">
                  Oggetto della pro-forma / fattura
                </Typography>
                <div
                  className="icon-modal-info"
                  style={{ marginLeft: "10px", cursor: "pointer" }}
                  onClick={() =>
                    handleModalClick(tooltipContent.pro_forma_fattura)
                  }
                />
              </div>
              <TextField
                multiline
                rows={5}
                style={{ marginTop: "10px" }}
                placeholder="Inserisci"
                variant="outlined"
                name="pro_forma_fattura"
                value={practice?.compenso?.pro_forma_fattura}
                onChange={(e) => handleChange(e.target.name, e.target.value)}
                error={errors.includes("pro_forma_fattura")}
                fullWidth
                sx={{
                  "& .MuiOutlinedInput-root": {
                    borderRadius: "0px",
                    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                      border: "1px solid #1b2838",
                    },
                  },
                }}
                InputProps={{
                  style: {
                    color: "#1b2838",
                  },
                }}
              />
            </Grid>

            <Grid xs={11} md={12} item style={{ paddingTop: "0px" }}>
              <Divider className="divider" />
            </Grid>

            {/* Modalità di compenso */}
            <Grid item xs={11} md={4}>
              <div
                style={{
                  display: "flex",
                  height: "20px",
                }}
              >
                <Typography className="color-blue-dark title-input">
                  Modalità di compenso
                </Typography>
              </div>
              <Select
                value={practice?.compenso?.modalità_compenso || ""}
                error={errors.includes("modalità_compenso")}
                onChange={(e) =>
                  handleChange("modalità_compenso", e.target.value)
                }
                displayEmpty
                fullWidth
                style={{ marginTop: "10px" }}
              >
                <MenuItem value="">
                  <span style={{ color: "#abb0b6" }}>Seleziona</span>
                </MenuItem>
                {modalitàCompenso.map((option, index) => (
                  <MenuItem key={index} value={option}>
                    {option}
                  </MenuItem>
                ))}
              </Select>
            </Grid>

            {practice?.compenso?.modalità_compenso === "Forfait" && (
              <>
                <Grid item xs={11} md={4}>
                  <div
                    style={{
                      display: "flex",
                      height: "20px",
                    }}
                  >
                    <Typography className="color-blue-dark title-input">
                      Compenso complessivo
                    </Typography>
                  </div>
                  <TextField
                    style={{ marginTop: "10px" }}
                    type="number"
                    placeholder="Inserisci"
                    sx={{
                      "& .MuiOutlinedInput-root": {
                        borderRadius: "0px",
                        "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                          border: "1px solid #1b2838",
                        },
                      },
                    }}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <Typography style={{ color: "#9e9e9e" }}>
                            €
                          </Typography>
                        </InputAdornment>
                      ),
                    }}
                    error={errors.includes("compenso_complessivo")}
                    variant="outlined"
                    fullWidth
                    value={practice?.compenso?.compenso_complessivo || ""}
                    name="compenso_complessivo"
                    onChange={(e) =>
                      handleChange(e.target.name, e.target.value)
                    }
                  />
                </Grid>

                <Grid item xs={11} md={4}>
                  <div
                    style={{
                      display: "flex",
                      height: "20px",
                    }}
                  >
                    <Typography className="color-blue-dark title-input">
                      Periodo di competenza
                    </Typography>
                  </div>

                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      marginTop: "10px",
                      marginRight: "15px",
                    }}
                  >
                    <Typography
                      className="color-blue-dark title-input"
                      style={{ marginRight: "18px", marginTop: "8px" }}
                    >
                      Dal
                    </Typography>

                    <LocalizationProvider
                      dateAdapter={AdapterDateFns}
                      locale={it}
                    >
                      <DatePicker
                        dateFormat="dd/MM/yyyy"
                        name="periodo_competenza_inizio"
                        value={
                          practice?.compenso?.periodo_competenza_inizio
                            ? parse(
                                practice.compenso.periodo_competenza_inizio,
                                "dd/MM/yyyy",
                                new Date()
                              )
                            : null
                        }
                        onChange={(newValue) => {
                          if (isValid(newValue)) {
                            handleChange(
                              "periodo_competenza_inizio",
                              format(newValue, "dd/MM/yyyy")
                            );
                          } else if (!newValue) {
                            handleChange("periodo_competenza_inizio", "");
                          }
                        }}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            fullWidth
                            placeholder="GG/MM/AAAA"
                            inputProps={{
                              ...params.inputProps,
                              placeholder: "GG/MM/AAAA",
                            }}
                          />
                        )}
                        slotProps={{
                          textField: {
                            format: "dd/MM/yyyy",
                            error: errors.includes("periodo_competenza_inizio"),
                            sx: {
                              width: "40%",
                              marginTop: "10px",
                              marginRight: "20px",
                              color: "#1b2838",
                              "& .MuiInputBase-input": {
                                color: "#1b2838",
                                border: "none",
                              },
                            },
                          },

                          openPickerButton: {
                            sx: {
                              color: "#9e9e9e",
                              backgroundColor: "transparent",
                              boxShadow: "none",
                              "&:hover": {
                                backgroundColor: "transparent",
                                boxShadow: "none",
                              },
                            },
                          },

                          day: {
                            sx: {
                              color: "#1b2838",
                              "&.Mui-selected": {
                                backgroundColor: "#bc2957 !important",
                                color: "white !important",
                                borderRadius: "50% !important",
                              },
                            },
                          },
                          calendarHeader: {
                            sx: {
                              color: "#1b2838",
                            },
                          },
                          yearButton: {
                            sx: {
                              color: "#1b2838",
                              "&.Mui-selected": {
                                backgroundColor: "#bc2957",
                                color: "#fff",
                                borderRadius: "8px",
                              },
                              "&:hover": {
                                backgroundColor: "rgba(188, 41, 87, 0.1)",
                              },
                            },
                          },

                          nextIconButton: {
                            sx: {
                              color: "#1b2838",
                            },
                          },
                          previousIconButton: {
                            sx: {
                              color: "#1b2838",
                            },
                          },
                          switchViewIcon: {
                            sx: {
                              color: "#1b2838",
                            },
                          },
                        }}
                      />
                    </LocalizationProvider>

                    <Typography
                      className="color-blue-dark title-input"
                      style={{
                        marginRight: "20px",
                        marginTop: "8px",
                        marginLeft: "15px",
                      }}
                    >
                      Al
                    </Typography>
                    <LocalizationProvider
                      dateAdapter={AdapterDateFns}
                      locale={it}
                    >
                      <DatePicker
                        error={errors.includes("periodo_competenza_fine")}
                        dateFormat="dd/MM/yyyy"
                        name="periodo_competenza_fine"
                        value={
                          practice?.compenso?.periodo_competenza_fine
                            ? parse(
                                practice.compenso.periodo_competenza_fine,
                                "dd/MM/yyyy",
                                new Date()
                              )
                            : null
                        }
                        onChange={(newValue) => {
                          if (isValid(newValue)) {
                            handleChange(
                              "periodo_competenza_fine",
                              format(newValue, "dd/MM/yyyy")
                            );
                          } else if (!newValue) {
                            handleChange("periodo_competenza_fine", "");
                          }
                        }}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            fullWidth
                            placeholder="GG/MM/AAAA"
                            inputProps={{
                              ...params.inputProps,
                              placeholder: "GG/MM/AAAA",
                            }}
                          />
                        )}
                        slotProps={{
                          textField: {
                            format: "dd/MM/yyyy",
                            error: errors.includes("periodo_competenza_fine"),
                            sx: {
                              width: "40%",
                              marginTop: "10px",
                              marginRight: "0px",
                              color: "#1b2838",
                              "& .MuiInputBase-input": {
                                color: "#1b2838",
                              },
                            },
                          },

                          openPickerButton: {
                            sx: {
                              color: "#9e9e9e",
                              backgroundColor: "transparent",
                              boxShadow: "none",
                              "&:hover": {
                                backgroundColor: "transparent",
                                boxShadow: "none",
                              },
                            },
                          },
                          day: {
                            sx: {
                              color: "#1b2838",
                              "&.Mui-selected": {
                                backgroundColor: "#bc2957 !important",
                                color: "white !important",
                                borderRadius: "50% !important",
                              },
                            },
                          },
                          calendarHeader: {
                            sx: {
                              color: "#1b2838",
                            },
                          },
                          yearButton: {
                            sx: {
                              color: "#1b2838",
                            },
                          },
                          nextIconButton: {
                            sx: {
                              color: "#1b2838",
                            },
                          },
                          previousIconButton: {
                            sx: {
                              color: "#1b2838",
                            },
                          },
                          switchViewIcon: {
                            sx: {
                              color: "#1b2838",
                            },
                          },
                        }}
                      />
                    </LocalizationProvider>
                  </div>
                </Grid>
              </>
            )}

            {practice?.compenso?.modalità_compenso === "Forfait" && (
              <>
                {/* <Grid item xs={11} md={4}></Grid> */}
                <Grid item xs={11} md={4}>
                  <div
                    style={{
                      display: "flex",
                      height: "20px",
                    }}
                  >
                    <Typography className="color-blue-dark title-input">
                      Dettagli della fatturazione del compenso
                    </Typography>
                  </div>
                  <TextField
                    multiline
                    rows={5}
                    style={{ marginTop: "10px" }}
                    placeholder="Indica la data di fatturazione per tutti i compensi previsti dall’incarico, comprese le eventuali success fee. Qualora la data esatta non fosse nota, indica comunque una data stimata"
                    variant="outlined"
                    name="dettagli_fatturazione_compenso"
                    value={
                      practice?.compenso?.dettagli_fatturazione_compenso || ""
                    }
                    error={errors.includes("dettagli_fatturazione_compenso")}
                    onChange={(e) =>
                      handleChange(e.target.name, e.target.value)
                    }
                    fullWidth
                    sx={{
                      "& .MuiOutlinedInput-root": {
                        borderRadius: "0px",
                        "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                          border: "1px solid #1b2838",
                        },
                      },
                    }}
                    InputProps={{
                      style: {
                        color: "#1b2838",
                      },
                    }}
                  />
                </Grid>
              </>
            )}

            {practice?.compenso?.modalità_compenso ===
              "Listino/Tariffa oraria" && (
              <>
                <Grid item xs={11} md={4}>
                  <div
                    style={{
                      height: "20px",
                    }}
                  >
                    <div style={{ display: "flex", height: "20px" }}>
                      <Typography className="color-blue-dark title-input">
                        Riferimento per il calcolo
                      </Typography>
                      <div
                        className="icon-modal-info"
                        style={{ marginLeft: "10px", cursor: "pointer" }}
                        onClick={() =>
                          handleModalClick(tooltipContent.riferimento_calcolo)
                        }
                      />
                    </div>

                    <Select
                      value={practice?.compenso?.riferimento_calcolo || ""}
                      error={errors.includes("riferimento_calcolo")}
                      onChange={(e) =>
                        handleChange("riferimento_calcolo", e.target.value)
                      }
                      displayEmpty
                      fullWidth
                      style={{ marginTop: "10px" }}
                    >
                      <MenuItem value="">
                        <span style={{ color: "#abb0b6" }}>Seleziona</span>
                      </MenuItem>
                      {listinoOptions.map((option, index) => (
                        <MenuItem key={index} value={option}>
                          {option}
                        </MenuItem>
                      ))}
                    </Select>
                  </div>
                </Grid>

                {practice?.compenso?.riferimento_calcolo ===
                "Listino personalizzato" ? (
                  <>
                    <Grid
                      item
                      xs={11}
                      md={4}
                      sx={{
                        paddingTop: {
                          xs: "90px !important",
                          md: "32px !important",
                        },
                      }}
                    >
                      <div
                        style={{
                          height: "20px",
                        }}
                      >
                        <div style={{ display: "flex", height: "20px" }}>
                          <Typography className="color-blue-dark title-input">
                            Tariffa specifica
                          </Typography>
                        </div>

                        <TextField
                          multiline
                          style={{ marginTop: "10px" }}
                          placeholder="Inserisci"
                          variant="outlined"
                          name="tariffa_specifica"
                          value={practice?.compenso?.tariffa_specifica || ""}
                          error={errors.includes("tariffa_specifica")}
                          onChange={(e) =>
                            handleChange(e.target.name, e.target.value)
                          }
                          fullWidth
                          sx={{
                            "& .MuiOutlinedInput-root": {
                              borderRadius: "0px",
                              "&.Mui-focused .MuiOutlinedInput-notchedOutline":
                                {
                                  border: "1px solid #1b2838",
                                },
                            },
                          }}
                          InputProps={{
                            style: {
                              color: "#1b2838",
                            },
                          }}
                        />
                      </div>
                    </Grid>
                  </>
                ) : null}

                {practice?.compenso?.riferimento_calcolo ===
                "Listino personalizzato" ? null : (
                  <>
                    {" "}
                    <Grid
                      item
                      xs={11}
                      md={4}
                      sx={{
                        paddingTop: {
                          xs: "0px !important",
                          md: "32px !important",
                        },
                      }}
                    ></Grid>
                  </>
                )}

                <Grid
                  item
                  xs={11}
                  md={4}
                  sx={{
                    paddingTop: {
                      xs: "90px !important",
                      md: "32px !important",
                    },
                    marginBottom: "152px",
                  }}
                >
                  <div
                    style={{
                      height: "20px",
                    }}
                  >
                    <div style={{ display: "flex", height: "20px" }}>
                      <Typography className="color-blue-dark title-input">
                        Note sul compenso o Cap (facoltativo)
                      </Typography>
                    </div>

                    <TextField
                      multiline
                      rows={5}
                      style={{ marginTop: "10px" }}
                      placeholder="Inserisci"
                      variant="outlined"
                      name="note_compenso_listino_tariffa_oraria"
                      value={
                        practice?.compenso
                          ?.note_compenso_listino_tariffa_oraria || ""
                      }
                      error={errors.includes(
                        "note_compenso_listino_tariffa_oraria"
                      )}
                      onChange={(e) =>
                        handleChange(e.target.name, e.target.value)
                      }
                      fullWidth
                      sx={{
                        "& .MuiOutlinedInput-root": {
                          borderRadius: "0px",
                          "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                            border: "1px solid #1b2838",
                          },
                        },
                      }}
                      InputProps={{
                        style: {
                          color: "#1b2838",
                        },
                      }}
                    />
                  </div>
                </Grid>
              </>
            )}

            {practice?.compenso?.modalità_compenso === "Mista" && (
              <>
                <Grid item xs={11} md={4}>
                  <div style={{ display: "flex", height: "20px" }}>
                    <Typography className="color-blue-dark title-input">
                      Listino/Tariffa oraria da applicare
                    </Typography>
                    <div
                      className="icon-modal-info"
                      style={{ marginLeft: "10px", cursor: "pointer" }}
                      onClick={() =>
                        handleModalClick(tooltipContent.Listino_Tariffa)
                      }
                    />
                  </div>
                  <Select
                    value={practice?.compenso?.tariffa_oraria || ""}
                    error={errors.includes("tariffa_oraria")}
                    onChange={(e) =>
                      handleChange("tariffa_oraria", e.target.value)
                    }
                    displayEmpty
                    fullWidth
                    style={{ marginTop: "10px" }}
                  >
                    <MenuItem value="">
                      <span style={{ color: "#abb0b6" }}>Seleziona</span>
                    </MenuItem>
                    {listinoOptions.map((option, index) => (
                      <MenuItem key={index} value={option}>
                        {option}
                      </MenuItem>
                    ))}
                  </Select>
                </Grid>

                {practice?.compenso?.tariffa_oraria ===
                "Listino personalizzato" ? (
                  <>
                    <Grid
                      item
                      xs={11}
                      md={4}
                      sx={{
                        paddingBottom: {
                          xs:
                            practice?.compenso?.modalità_compenso === "Mista"
                              ? "92px !important"
                              : "0px !important",
                        },
                      }}
                    >
                      <div
                        style={{
                          height: "20px",
                        }}
                      >
                        <div style={{ display: "flex", height: "20px" }}>
                          <Typography className="color-blue-dark title-input">
                            Tariffa specifica
                          </Typography>
                        </div>

                        <TextField
                          multiline
                          style={{ marginTop: "10px" }}
                          placeholder="Inserisci"
                          variant="outlined"
                          name="tariffa_specifica"
                          value={practice?.compenso?.tariffa_specifica || ""}
                          error={errors.includes("tariffa_specifica")}
                          onChange={(e) =>
                            handleChange(e.target.name, e.target.value)
                          }
                          fullWidth
                          sx={{
                            "& .MuiOutlinedInput-root": {
                              borderRadius: "0px",
                              "&.Mui-focused .MuiOutlinedInput-notchedOutline":
                                {
                                  border: "1px solid #1b2838",
                                },
                            },
                          }}
                          InputProps={{
                            style: {
                              color: "#1b2838",
                            },
                          }}
                        />
                      </div>
                    </Grid>
                  </>
                ) : (
                  <Grid item xs={11} md={4}></Grid>
                )}
              </>
            )}

            {practice?.compenso?.modalità_compenso === "Mista" && (
              <>
                <Grid
                  item
                  xs={11}
                  md={4}
                  sx={{
                    paddingTop: {
                      xs:
                        practice?.compenso?.modalità_compenso === "Mista" &&
                        practice?.compenso?.tariffa_oraria ===
                          "Listino personalizzato"
                          ? "0px !important"
                          : "32px !important",
                    },
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      height: "40px",
                    }}
                  >
                    <Typography className="color-blue-dark title-input">
                      Dettagli del compenso a forfait e della sua combinazione
                      con il listino selezionato
                    </Typography>
                  </div>
                  <TextField
                    multiline
                    rows={5}
                    style={{ marginTop: "10px" }}
                    placeholder="Inserisci"
                    variant="outlined"
                    name="compenso_combinazione_forfait_listino"
                    value={
                      practice?.compenso
                        ?.compenso_combinazione_forfait_listino || ""
                    }
                    error={errors.includes(
                      "compenso_combinazione_forfait_listino"
                    )}
                    onChange={(e) =>
                      handleChange(e.target.name, e.target.value)
                    }
                    fullWidth
                    sx={{
                      "& .MuiOutlinedInput-root": {
                        borderRadius: "0px",
                        "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                          border: "1px solid #1b2838",
                        },
                      },
                    }}
                    InputProps={{
                      style: {
                        color: "#1b2838",
                      },
                    }}
                  />
                </Grid>
              </>
            )}

            <Grid
              xs={11}
              md={12}
              item
              sx={{
                paddingTop: { xs: "32px !important", md: "0px !important" },
              }}
            >
              <Divider className="divider-none" />
            </Grid>

            {/* Percentuale di spese generali da applicare */}
            <Grid
              item
              xs={11}
              md={4}
              sx={{
                paddingTop: {
                  xs:
                    practice?.compenso?.modalità_compenso ===
                    "Listino/Tariffa oraria"
                      ? "0px !important"
                      : "0px !important",
                  md: "32px !important",
                },
              }}
            >
              <div
                style={{
                  display: "flex",
                  height: "20px",
                }}
              >
                <Typography className="color-blue-dark title-input">
                  Percentuale di spese generali da applicare
                </Typography>
              </div>
              <Select
                value={practice?.compenso?.percentuale_spese || ""}
                error={errors.includes("percentuale_spese")}
                onChange={(e) =>
                  handleChange("percentuale_spese", e.target.value)
                }
                displayEmpty
                fullWidth
                style={{ marginTop: "10px" }}
              >
                <MenuItem value="">
                  <span style={{ color: "#abb0b6" }}>Seleziona</span>
                </MenuItem>
                {percentualeSpese.map((option, index) => (
                  <MenuItem key={index} value={option}>
                    {option}
                  </MenuItem>
                ))}
              </Select>
            </Grid>

            {/* Percentuale specifica */}
            {practice?.compenso?.percentuale_spese === "Altra percentuale" ? (
              <>
                <Grid item xs={11} md={4}>
                  <div
                    style={{
                      display: "flex",
                      height: "20px",
                    }}
                  >
                    <Typography className="color-blue-dark title-input">
                      Percentuale specifica
                    </Typography>
                  </div>
                  <TextField
                    placeholder="Inserisci"
                    style={{ marginTop: "10px" }}
                    type="text"
                    sx={{
                      "& .MuiOutlinedInput-root": {
                        borderRadius: "0px",
                        "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                          border: "1px solid #1b2838",
                        },
                      },
                    }}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <Typography style={{ color: "#9e9e9e" }}>
                            %
                          </Typography>
                        </InputAdornment>
                      ),
                    }}
                    error={errors.includes("percentuale_spese_specifica")}
                    variant="outlined"
                    fullWidth
                    value={
                      practice?.compenso?.percentuale_spese_specifica || ""
                    }
                    name="percentuale_spese_specifica"
                    onChange={(e) => {
                      let value = e.target.value.replace(/[^0-9,]/g, "");

                      if ((value.match(/,/g) || []).length > 1) {
                        value = value.replace(/,(?=.*,)/g, "");
                      }

                      if (value.includes(",")) {
                        const [integerPart, decimalPart] = value.split(",");

                        value = `${integerPart},${decimalPart.substring(0, 2)}`;
                      }

                      const numericValue = value.replace(",", "");

                      if (
                        numericValue.length <= 5 &&
                        (value === "" ||
                          parseFloat(value.replace(",", ".")) <= 100)
                      ) {
                        handleChange(e.target.name, value);
                      }
                    }}
                  />
                </Grid>
              </>
            ) : null}

            {/* Compenso diviso */}
            <Grid item xs={11} md={4}>
              <div
                style={{
                  display: "flex",
                  height: "20px",
                }}
              >
                <Typography className="color-blue-dark title-input">
                  Il compenso dovrà essere ripartito con altri team LEXIA?
                </Typography>
              </div>
              <Select
                value={practice?.compenso?.compenso_condiviso || ""}
                error={errors.includes("compenso_condiviso")}
                onChange={(e) =>
                  handleChange("compenso_condiviso", e.target.value)
                }
                displayEmpty
                fullWidth
                style={{ marginTop: "10px" }}
              >
                <MenuItem value="">
                  <span style={{ color: "#abb0b6" }}>Seleziona</span>
                </MenuItem>
                {compensoCondiviso.map((option, index) => (
                  <MenuItem key={index} value={option}>
                    {option}
                  </MenuItem>
                ))}
              </Select>
            </Grid>

            {practice?.compenso?.compenso_condiviso === "Sì" && (
              <>
                <Grid item xs={11} md={4}>
                  <div
                    style={{
                      display: "flex",
                      height: "20px",
                    }}
                  >
                    <Typography className="color-blue-dark title-input">
                      Aggiungi team
                    </Typography>
                  </div>

                  <Select
                    multiple
                    value={
                      practice?.compenso?.team_compenso_condiviso?.map(
                        (team) => team.name
                      ) || []
                    }
                    error={errors.includes("team_compenso_condiviso")}
                    onChange={(e) => {
                      const selectedValues = e.target.value;
                      const selectedTeams = filteredTeamArray.filter((item) =>
                        selectedValues.includes(item.name)
                      );
                      handleChange("team_compenso_condiviso", selectedTeams);
                    }}
                    displayEmpty
                    fullWidth
                    style={{ marginTop: "10px" }}
                    renderValue={(selected) =>
                      selected.length ? (
                        selected.join(", ")
                      ) : (
                        <span className="color-blue-dark">Seleziona</span>
                      )
                    }
                  >
                    {filteredTeamArray.map((item) => (
                      <MenuItem key={item.name} value={item.name}>
                        <Checkbox
                          className="color-blue-dark"
                          checked={practice?.compenso?.team_compenso_condiviso?.some(
                            (team) => team.name === item.name
                          )}
                        />
                        <ListItemText
                          className="color-blue-dark"
                          primary={item.name}
                        />
                      </MenuItem>
                    ))}
                  </Select>
                </Grid>
              </>
            )}

            {practice?.compenso?.compenso_condiviso === "Sì" && (
              <>
                <Grid item xs={11} md={4}>
                  <div
                    style={{
                      display: "flex",
                      height: "20px",
                    }}
                  >
                    <Typography className="color-blue-dark title-input">
                      Dettagli della ripartizione
                    </Typography>
                  </div>
                  <TextField
                    value={practice?.compenso?.dettagli_divisione || ""}
                    error={errors.includes("dettagli_divisione")}
                    onChange={(e) =>
                      handleChange("dettagli_divisione", e.target.value)
                    }
                    style={{ marginTop: "10px" }}
                    multiline
                    rows={5}
                    placeholder="Inserisci"
                    variant="outlined"
                    fullWidth
                    sx={{
                      "& .MuiOutlinedInput-root": {
                        borderRadius: "0px",
                        "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                          border: "1px solid #1b2838",
                        },
                      },
                    }}
                    InputProps={{
                      style: {
                        color: "#1b2838",
                      },
                    }}
                  />
                </Grid>
              </>
            )}

            <Grid xs={11} md={12} item style={{ paddingTop: "0px" }}>
              <Divider className="divider" />
            </Grid>

            {/* Condizioni di pagamento */}
            <Grid item xs={11} md={4}>
              <div
                style={{
                  display: "flex",
                  height: "20px",
                }}
              >
                <Typography className="color-blue-dark title-input">
                  Condizioni di pagamento
                </Typography>
              </div>
              <Select
                value={practice?.compenso?.condizioni_pagamento || ""}
                error={errors.includes("condizioni_pagamento")}
                onChange={(e) =>
                  handleChange("condizioni_pagamento", e.target.value)
                }
                displayEmpty
                fullWidth
                style={{ marginTop: "10px" }}
              >
                <MenuItem value="">
                  <span style={{ color: "#abb0b6" }}>Seleziona</span>
                </MenuItem>
                {condizioniPagamento.map((option, index) => (
                  <MenuItem key={index} value={option}>
                    {option}
                  </MenuItem>
                ))}
              </Select>
            </Grid>

            {/* LEXIA dovrà versare... */}
            <Grid item xs={11} md={4}>
              <div
                style={{
                  display: "flex",
                  height: "20px",
                }}
              >
                <Typography className="color-blue-dark title-input">
                  LEXIA dovrà versare dei compensi a soggetti in outsourcing?
                </Typography>
              </div>
              <Select
                value={practice?.compenso?.compensi_outsourcing || ""}
                error={errors.includes("compensi_outsourcing")}
                onChange={(e) =>
                  handleChange("compensi_outsourcing", e.target.value)
                }
                displayEmpty
                fullWidth
                style={{ marginTop: "10px" }}
              >
                <MenuItem value="">
                  <span style={{ color: "#abb0b6" }}>Seleziona</span>
                </MenuItem>
                {compensiOutsourcing.map((option, index) => (
                  <MenuItem key={index} value={option}>
                    {option}
                  </MenuItem>
                ))}
              </Select>
            </Grid>

            {practice?.compenso?.compensi_outsourcing === "Sì" && (
              <>
                <Grid
                  item
                  xs={11}
                  md={4}
                  sx={{
                    paddingTop: { xs: "32px !important", md: "0px !important" },
                  }}
                ></Grid>
                <Grid
                  item
                  xs={11}
                  md={4}
                  sx={{
                    paddingTop: {
                      xs: "0px !important",
                      md: "32px !important",
                    },
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      height: "20px",
                    }}
                  >
                    <Typography className="color-blue-dark title-input">
                      Dettagli dei compensi per outsourcing
                    </Typography>
                    <div
                      className="icon-modal-info"
                      style={{ marginLeft: "10px", cursor: "pointer" }}
                      onClick={() =>
                        handleModalClick(
                          tooltipContent.dettagli_compensi_outsourcing
                        )
                      }
                    />
                  </div>
                  <TextField
                    multiline
                    rows={5}
                    style={{ marginTop: "10px" }}
                    placeholder="Inserisci"
                    variant="outlined"
                    fullWidth
                    sx={{
                      "& .MuiOutlinedInput-root": {
                        borderRadius: "0px",
                        "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                          border: "1px solid #1b2838",
                        },
                      },
                    }}
                    InputProps={{
                      style: {
                        color: "#1b2838",
                      },
                    }}
                    value={
                      practice?.compenso?.dettagli_compensi_outsourcing || ""
                    }
                    error={errors.includes("dettagli_compensi_outsourcing")}
                    onChange={(e) =>
                      handleChange(
                        "dettagli_compensi_outsourcing",
                        e.target.value
                      )
                    }
                  />
                </Grid>
              </>
            )}
          </Grid>
        </Grid>
      </Grid>

      <Modal open={modalOpen} onClose={handleCloseModal}>
        <div>
          <ModalHelper
            onClose={handleCloseModal}
            modalObjectInfo={modalObjectInfo}
          />
        </div>
      </Modal>
    </>
  );
};

export default CompensationComponent;
